module.exports = __webpack_public_path__ + "static/media/controlled_brush.e92268f0.jpg";